/**
 * @fileoverview NewOutputBadge — compact "New" pill for freshly-created rows.
 *
 * Purpose:
 * - Flag an entity row (creditor, asset, POD, ...) that was created after the
 *   user last viewed the agent's outputs, so they can spot new items to
 *   cross-check.
 *
 * Rendered next to a row's primary label. A SOLID primary-green pill sharing
 * {@link NEW_OUTPUT_ACCENT_CLASS} with the sidebar's completed-run pill, so a
 * "new result" reads the same wherever it appears. The status badges in these
 * tables (ranking, confidence, source, nature) are all soft/pastel, so a filled
 * pill still stands clearly apart from them.
 */

import { cn } from "@/utils/misc";
import {
  NEW_OUTPUT_ACCENT_CLASS,
  NEW_OUTPUT_TITLE,
} from "./use-new-output-boundary";

/**
 * Small solid primary-green "New" badge.
 *
 * @component
 * @example
 * {isNewOutput(entry._creationTime, newSince) && <NewOutputBadge />}
 */
export function NewOutputBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white",
        NEW_OUTPUT_ACCENT_CLASS,
        className,
      )}
      title={NEW_OUTPUT_TITLE}
    >
      New
    </span>
  );
}
